var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7778 8.05556C16.5566 7.42804 16.1527 6.88107 15.6181 6.48504C15.0834 6.08901 14.4425 5.86203 13.7778 5.83333H9.33333C8.44928 5.83333 7.60143 6.18452 6.97631 6.80964C6.35119 7.43477 6 8.28261 6 9.16667C6 10.0507 6.35119 10.8986 6.97631 11.5237C7.60143 12.1488 8.44928 12.5 9.33333 12.5H13.7778C14.6618 12.5 15.5097 12.8512 16.1348 13.4763C16.7599 14.1014 17.1111 14.9493 17.1111 15.8333C17.1111 16.7174 16.7599 17.5652 16.1348 18.1904C15.5097 18.8155 14.6618 19.1667 13.7778 19.1667H9.33333C8.66861 19.138 8.02768 18.911 7.49303 18.515C6.95839 18.1189 6.5545 17.572 6.33333 16.9444M11.5556 2.5V5.83333M11.5556 19.1667V22.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.ca32b97143b1c907d74cd27724dd0383.svg";
export { ForwardRef as ReactComponent };